<div class="app-container">
  <public-header></public-header>
  <ng-container *ngIf="!isLoading; else loading">
    <ng-container *ngIf="isValid; else notFound">
      <main class="main-content">
        <section class="provider-profile">
          <div class="provider-header">
            <br *ngIf="noProfilePhoto">
            <div *ngIf="!noProfilePhoto" class="image-container">
              <img 
                src="{{ providerShareableProfile.profile_photo_url }}" 
                alt="{{ providerShareableProfile.display_name }} profile image" 
                class="provider-image"
                fetchpriority="high"
              >
            </div>

            <div class="provider-header-details">
              <div class="names-and-pronouns-container">
                <h1 class="provider-name" data-test="provider-display-name">{{ providerShareableProfile.display_name }}</h1>
                <span class="provider-pronouns" *ngIf="providerShareableProfile?.pronouns?.length > 0">
                  ({{ providerShareableProfile.pronouns }})
                </span>
              </div>
              <p class="provider-credentials" *ngFor="let certification of providerShareableProfile.certifications">
                {{ certification.name }}
              </p>
              
              <div class="type-and-insurance-container">
                <p class="provider-session-type">
                  <img
                    src="../assets/place.png"
                    alt="location icon" 
                    fetchpriority="low"
                  >
                  {{sessionTypeList}}
                </p>
                <p *ngIf="providerShareableProfile?.credentialed_states?.length > 0" class="provider-state">
                  Practicing in {{credentialStatesFormatted}}
                </p>
                <p class="provider-header-insurance-title">
                  <img
                    src="../assets/shield.png"
                    alt="shield icon"
                    fetchpriority="low"
                  >
                  Insurance
                </p>
                <p class="provider-header-insurances-accepted">
                  {{ providerInsurances | slice:0:36 }}{{providerInsurances.length > 36 ? '...' : ''}}
                </p>
                <button 
                  class="show-insurance-list-button" 
                  *ngIf="providerInsurances.length > 36" 
                  (click)="scrollToElement('insurances-section')"
                  data-test="show-insurance-list-button"
                >
                  See all below
                </button>
              </div>
              <div
                *ngIf="providerShareableProfile.psl_feature_flag && !isMobile"
                class="scheduling-container"
                data-test="scheduling-container"
              >
                <a
                  *ngIf="providerShareableProfile.accepting_clients; else notCurrentlyAccepting"
                  [routerLink]="['/match', paramsShareCode, paramsName]"
                  [queryParams]="paramsAnonUserId ? { anonUserId: paramsAnonUserId } : {}"
                  class="nav-link request-session-button"
                  data-test="request-session-button"
                >
                  Request a Session
                </a>

                <ng-template #notCurrentlyAccepting>
                  <p class="not-accepting-clients">Not currently accepting new clients</p>
                  <a 
                    class="get-connected-link"
                    data-test="get-connected-link" 
                    href="https://www.sondermind.com/match"
                  >
                    Get connected with another therapist
                  </a>
                </ng-template>
              </div>
            </div>
          </div>
        </section>
        <div *ngIf="providerShareableProfile.psl_feature_flag && isMobile" class="mobile-request-session-container">
          <a 
            *ngIf="providerShareableProfile.accepting_clients; else notCurrentlyAcceptingMobile"
            [routerLink]="['/match', paramsShareCode, paramsName]"
            [queryParams]="paramsAnonUserId ? { anonUserId: paramsAnonUserId } : {}"
            class="request-session-button-mobile"
          >
            Request a Session
          </a>

          <ng-template #notCurrentlyAcceptingMobile>
            <p class="not-accepting-clients-mobile">Not currently accepting new clients</p>
            <a class="get-connected-link-mobile" href="https://www.sondermind.com/match">Get connected with another therapist</a>
          </ng-template>
        </div>

    
        <div class="provider-details">
          <section class="info" *ngIf="providerShareableProfile?.specialties?.length > 0">
            <section class="specialties">
              <h2>Specialties</h2>
              <ul>
                <li *ngFor="let specialty of providerShareableProfile.specialties">
                  {{ specialty.name }}
                </li>
              </ul>
            </section>
          
            <section *ngIf="experienceSupportingList?.length > 0" class="experience">
              <h2>Experience Supporting</h2>
              <ul>
                <li *ngFor="let experience of experienceSupportingList">
                  {{ experience }}
                </li>
              </ul>
            </section>
          </section>

          <section
            *ngIf="providerBio?.length"
            id="about-section"
            class="about"
          >
            <h2>About</h2>
            <p data-test="provider-bio">{{providerBio}}</p>
            <p
              *ngIf="isBioTruncated && providerBio.length >= 500"
              (click)="toggleBioTruncation()"
              class="read-more"
            >
              read more
            </p>
            <p
              *ngIf="!isBioTruncated && providerBio.length >=500"
              (click)="toggleBioTruncation()"
              class="read-more"
            >
              read less
            </p>
          </section>

          <section id="insurances-section" class="insurance">
            <h2>Insurance</h2>
            <ul>
              <li *ngFor="let insurance of providerShareableProfile.insurances">
                {{ insurance }}
              </li>
            </ul>
          </section>
        </div>

        <!-- Footer is contained within main to have body + footer be scrollable together -->
        <footer >
          <public-footer [therapyMatchFlowUrl]="therapyMatchFlowUrl" [psychiatryMatchFlowUrl]="psychiatryMatchFlowUrl">
          </public-footer>
        </footer>
      </main>
    </ng-container>

    <ng-template #notFound>
      <div class="not-found-container">
        <h1>Oops! It looks like the page you've landed on does not exist or is not yet available.</h1>
          
        <p class="not-found-subtitle">
          SonderMind is a mental health care provider, connecting you with a therapist 
          or psychiatrist who takes your insurance and has availability within a week.
        </p>
        <br>
        <div class="not-found-buttons">
          <a
            href="{{therapyMatchFlowUrl}}"
            target="_blank"
            rel="noopener noreferrer"
            data-test="match-flow-url"
          >
            <iris-button class="find-care-button">
              Find care
            </iris-button>
          </a>
        </div>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loading>
    <mat-spinner [diameter]="40"></mat-spinner>
  </ng-template>
</div>
  